import { auth } from '../services/auth.js';

function draftKey(kind: string, id: string, expectedOwner?: string | null): string | null {
  const owner = auth.getUserId();
  if (expectedOwner !== undefined && owner !== expectedOwner) return null;
  return owner
    ? `xdface.draft:${encodeURIComponent(owner)}:${kind}:${encodeURIComponent(id)}`
    : null;
}

export function readDraft<T>(kind: string, id: string, expectedOwner?: string | null): T | null {
  try {
    const key = draftKey(kind, id, expectedOwner);
    const raw = key && localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeDraft<T>(
  kind: string,
  id: string,
  value: T,
  expectedOwner?: string | null,
): boolean {
  try {
    const key = draftKey(kind, id, expectedOwner);
    if (!key) return false;
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function clearDraft<T>(
  kind: string,
  id: string,
  expected: T,
  expectedOwner?: string | null,
): void {
  try {
    const key = draftKey(kind, id, expectedOwner);
    if (key && localStorage.getItem(key) === JSON.stringify(expected)) localStorage.removeItem(key);
  } catch {
    /* A failed cleanup must not remove a newer draft. */
  }
}
